import { useQuery } from "@tanstack/react-query";
import { FileText, FolderArchive } from "lucide-react";
import { Button } from "@/components/ui/button";

const BASE = "/downloads/architecture";
const KEY = [["bg-[#1F4D3A]", "Onboard component"], ["border border-[#1B1E1A] bg-white", "Data store"], ["border border-[#A9832F] bg-[#F3E7CC]", "External service"],
  ["border border-dashed border-[#A9832F]", "Optional / not configured"], ["border border-[#1F4D3A] bg-[#E7EFE9]", "Person"]];

export default function ArchitecturePage() {
  const { data } = useQuery({ queryKey: ["arch-index"], queryFn: () => fetch(`${BASE}/index.json`).then((r) => r.json()) });
  return (
    <div className="min-h-screen bg-canvas" data-testid="architecture-page">
      <main className="mx-auto max-w-[1200px] px-6 py-14 max-sm:px-4 max-sm:py-8">
        <p className="font-display text-sm font-semibold text-brand">Onboard</p>
        <h1 className="mt-6 font-display text-4xl font-medium text-ink max-sm:text-[28px]">Architecture and data flow</h1>
        <p className="mt-3 max-w-2xl text-ink-secondary">Seven diagrams generated from the codebase: system context, containers, the hiring data flow, assessments, AI and LLM use, security and privacy, and the data model. No secret values are included.</p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Button asChild data-testid="arch-download-pdf"><a href="/downloads/Onboard_Architecture.pdf" download><FileText size={16} /> Download PDF</a></Button>
          <Button asChild variant="outline" data-testid="arch-download-zip"><a href="/downloads/Onboard_Architecture_Diagrams.zip" download><FolderArchive size={16} /> SVG + PNG (.zip)</a></Button>
        </div>
        <ul className="mt-6 flex flex-wrap gap-x-5 gap-y-2 text-xs text-ink-secondary" data-testid="arch-legend">
          {KEY.map(([c, l]) => <li key={l} className="inline-flex items-center gap-2"><span className={`inline-block h-3 w-5 rounded-[2px] ${c}`} />{l}</li>)}
        </ul>
        <div className="mt-10 space-y-14">
          {(data || []).map((d, i) => (
            <section key={d.id} data-testid={`arch-diagram-${d.id}`}>
              <p className="text-xs font-semibold uppercase tracking-wide text-brand">Diagram {String(i + 1).padStart(2, "0")}</p>
              <h2 className="mt-1 font-display text-2xl text-ink">{d.title}</h2>
              <p className="mt-2 max-w-3xl text-sm text-ink-secondary">{d.caption}</p>
              <a href={`${BASE}/${d.id}.svg`} target="_blank" rel="noreferrer" className="mt-4 block overflow-x-auto rounded-[6px] border border-line bg-[#FBFAF6] p-3">
                <img src={`${BASE}/${d.id}.png`} alt={d.title} loading="lazy" className="mx-auto max-w-full max-lg:max-w-none max-lg:w-[900px]" />
              </a>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
}
